"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Info2_exports = {};
__export(Info2_exports, {
  default: () => Info2_default
});
module.exports = __toCommonJS(Info2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 3.58984C11.4245 3.58984 12.2904 3.75911 13.0977 4.09766C13.9049 4.44922 14.6081 4.93099 15.207 5.54297C15.819 6.14193 16.3008 6.84505 16.6523 7.65234C16.9909 8.45964 17.1602 9.32552 17.1602 10.25C17.1602 11.1745 16.9909 12.0404 16.6523 12.8477C16.3008 13.6549 15.819 14.3646 15.207 14.9766C14.6081 15.5755 13.9049 16.0508 13.0977 16.4023C12.2904 16.7409 11.4245 16.9102 10.5 16.9102C9.57552 16.9102 8.70964 16.7409 7.90234 16.4023C7.09505 16.0508 6.38542 15.5755 5.77344 14.9766C5.17448 14.3646 4.69922 13.6549 4.34766 12.8477C4.00911 12.0404 3.83984 11.1745 3.83984 10.25C3.83984 9.32552 4.00911 8.45964 4.34766 7.65234C4.69922 6.84505 5.17448 6.14193 5.77344 5.54297C6.38542 4.93099 7.09505 4.44922 7.90234 4.09766C8.70964 3.75911 9.57552 3.58984 10.5 3.58984ZM10.5 4.80078C9.74479 4.80078 9.03516 4.94401 8.37109 5.23047C7.70703 5.51693 7.1276 5.90755 6.63281 6.40234C6.15104 6.88411 5.76693 7.45703 5.48047 8.12109C5.19401 8.78516 5.05078 9.49479 5.05078 10.25C5.05078 11.0052 5.19401 11.7148 5.48047 12.3789C5.76693 13.043 6.15104 13.6224 6.63281 14.1172C7.1276 14.599 7.70703 14.9831 8.37109 15.2695C9.03516 15.556 9.74479 15.6992 10.5 15.6992C11.2552 15.6992 11.9648 15.556 12.6289 15.2695C13.293 14.9831 13.8659 14.599 14.3477 14.1172C14.8424 13.6224 15.2331 13.043 15.5195 12.3789C15.806 11.7148 15.9492 11.0052 15.9492 10.25C15.9492 9.49479 15.806 8.78516 15.5195 8.12109C15.2331 7.45703 14.8424 6.88411 14.3477 6.40234C13.8659 5.90755 13.293 5.51693 12.6289 5.23047C11.9648 4.94401 11.2552 4.80078 10.5 4.80078ZM11.1055 12.6719C11.1055 12.8411 11.0469 12.9844 10.9297 13.1016C10.8125 13.2188 10.6693 13.2773 10.5 13.2773C10.3307 13.2773 10.1875 13.2188 10.0703 13.1016C9.95312 12.9844 9.89453 12.8411 9.89453 12.6719V10.25C9.89453 10.0807 9.95312 9.9375 10.0703 9.82031C10.1875 9.70312 10.3307 9.64453 10.5 9.64453C10.6693 9.64453 10.8125 9.70312 10.9297 9.82031C11.0469 9.9375 11.1055 10.0807 11.1055 10.25V12.6719ZM10.9297 8.00391C11.0469 8.12109 11.1055 8.26432 11.1055 8.43359C11.1055 8.60286 11.0469 8.74609 10.9297 8.86328C10.8125 8.98047 10.6693 9.03906 10.5 9.03906C10.3307 9.03906 10.1875 8.98047 10.0703 8.86328C9.95312 8.74609 9.89453 8.60286 9.89453 8.43359C9.89453 8.26432 9.95312 8.12109 10.0703 8.00391C10.1875 7.88672 10.3307 7.82812 10.5 7.82812C10.6693 7.82812 10.8125 7.88672 10.9297 8.00391Z",
      fill: "currentColor"
    }
  )
);
const SvgInfo2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Info2_default = SvgInfo2;
